import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from "@angular/core";
import { SafeHtml } from "@angular/platform-browser";
import { TranslateModule } from "@ngx-translate/core";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";

@Component({
  selector: "app-offer-card",
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, TranslateModule],
  templateUrl: "./offer-card.component.html",
  styleUrl: "./offer-card.component.scss",
})
export class OfferCardComponent implements AfterViewInit {
  @Input({ required: true }) header!: string;
  @Input({ required: true }) description!: SafeHtml;
  @Input({ required: true }) quotationProductCode!: string;
  @Input() aboutLink: string | undefined;
  @Input() showResourcesLimitsButton: boolean | undefined;
  @Output() showResourcesLimits: EventEmitter<void> = new EventEmitter<void>();
  @Output() createQuotation: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild("htmlDescription") htmlDescription!: ElementRef;

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    // Create links in description on top of translation
    setTimeout(() => {
      const openResourcesLimitsElements = this.htmlDescription.nativeElement.querySelectorAll(".openResourcesLimits");

      openResourcesLimitsElements.forEach((element: HTMLElement) => {
        this.renderer.listen(element, "click", event => {
          event.preventDefault();
          this.showResourcesLimitsButtonClick();
        });
      });
    }, 0); // Delay to ensure content is rendered
  }

  showResourcesLimitsButtonClick() {
    this.showResourcesLimits.emit();
  }

  createQuotationClick() {
    this.createQuotation.emit(this.quotationProductCode);
  }
}
